import {h, Fragment} from "preact"
export default function Checkbox({ value, count, selected, onChange, className }) {
    return (
        <label className={`ns-checkbox ns-d-flex`}>
            {(() => { try { return JSON.parse(value).join(', ') } catch { return value } })()} ({count})
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark ns-d-flex ns-justify-content-center ns-align-items-center border">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 10" fill="none">
                    <path d="M1 5.31086L4.17794 8.48881L11 1.66675" stroke="currentColor" />
                </svg>
            </span>
        </label>
    )
}